// extracted by mini-css-extract-plugin
module.exports = {"box":"IJaef","orange":"IJpb","transparent":"IJaeh","lightOrange":"IJaej"};